import { render, staticRenderFns } from "./UcCompanyStatement.yaml?vue&type=template&id=139a6925&component"
import script from "./UcCompanyStatement.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyStatement.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports